import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrollt bei jedem Routenwechsel nach oben. Seit 11.10.2026 mit Anker: Links wie
 * `/hundetagesstaette#warteliste` (Service-Finder, /preise, Blog) springen direkt ins Formular.
 * Die Zielseite ist lazy, das Element gibt es also oft erst nach ein paar Frames; deshalb kurz
 * nachfassen (max. ~2 s) und danach still aufgeben. Kein Effekt auf Seiten ohne Hash.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const id = hash ? decodeURIComponent(hash.slice(1)) : "";
    if (!id) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
      return;
    }
    let versuche = 0;
    let timer = 0;
    const springen = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ block: "start" });
        return;
      }
      if (++versuche < 20) timer = window.setTimeout(springen, 100);
    };
    springen();
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
};
